@if (ticketUserChange(); as ticketStatusChange) {
  @let createdByUser = ticketStatusChange?.createdByUser;
  <div [class.table-style]="tableStyle()" class="work-ui-timeline__item">
    <div class="work-ui-timeline__item-badge">
      <div class="work-ui-timeline__item-badge-icon"></div>
    </div>
    <div class="work-ui-timeline__item-body">
      <div class="work-ui-timeline__item__meta flex gap-48 space-between margin-bottom-4" style="height: 40px">
        <div class="flex flex-row vertical-center gap-8">
          @if (createdByUser) {
            <work-ui-avatar
              [imgSrc]="createdByUser && createdByUser.userImage ? (createdByUser.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
              [size]="'mini'" />
          }
          <div class="flex flex-column gap-2">
            <div>
              <small
                class="work-text-color-light work-text-size-micro">{{ ticketStatusChange.created | formatDate: 'DD.MM.YYYY, HH:mm [Uhr]' }}</small>
            </div>
            <p>
              @if (createdByUser) {
                <a
                  [routerLink]="'/mitarbeiter/details/' + ticketStatusChange.createdBy"><b>{{ createdByUser.firstName }} {{ createdByUser.lastName }}</b></a>@if (!tableStyle()) {
                  {{ 'TICKET_ZUGEWIESEN_PREFIX' | translate }}
                }
              }
              @if (!tableStyle() && ticketStatusChange.user) {
                <b>{{ ticketStatusChange.user.firstName }} {{ ticketStatusChange.user.lastName }}</b>
              }
              @if (createdByUser) {
                {{ 'TICKET_ZUGEWIESEN_SUFFIX' | translate }}
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
